import { z } from 'zod';
/**
 * Switch vs move-in (E-SF03 prose). A premise that is currently ACTIVE with an
 * incumbent REP is a SWITCH (rescission + switch-hold rules apply downstream);
 * a premise with no active service is a MOVE_IN (start-date/AMS same-day rules).
 * The distinction is decided server-side from the premise's service status +
 * incumbent-REP presence, never guessed in the browser.
 *
 * ── WHY ITS OWN MODULE ─────────────────────────────────────────────────────
 * It is shared by `address`, `meter`, `status` and `sign`. Since `address` now
 * embeds a `meter` (and `meter` carries an `enrollmentType`), keeping this enum
 * in `address` would make `address ↔ meter` a CIRCULAR import (which corrupts the
 * zod schemas at module-eval time). This leaf module breaks the cycle: everyone
 * imports the enum from here, and `address → meter → enrollment-type` stays acyclic.
 */
export const EnrollmentType = z.enum(['SWITCH', 'MOVE_IN']);
//# sourceMappingURL=enrollment-type.js.map